import { render, staticRenderFns } from "./WesAnswerExplaination.vue?vue&type=template&id=2709d6a4&scoped=true"
import script from "./WesAnswerExplaination.vue?vue&type=script&lang=js"
export * from "./WesAnswerExplaination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2709d6a4",
  null
  
)

export default component.exports